<template>
  <div :class="['topsPage', {
    isIos: isIos && !isIos12 && !over1190
  }]">
    <div class="navWarp" :class="[onType, {isIos: isIos && !over1190},{isIos12: isIos12}, current]" ref="navWarpRF"> <!--  v-if="topIsShow" -->
      <div class="navWrapPos">
        <ul class="headNav">
          <div class="swiper2 tab2">
            <div class="swiper-container">
                <div class="swiper-wrapper" style="display: flex;">
                    <li
                      v-for="(item, index) in navList"
                      @click="changeNav(item)"
                      :key="index"
                      :class="['swiper-slide', { current: current === item.type }]"
                    >
                      <img
                        :src="item.ico"
                        :class="'img' + index"
                      />
                      <div class="name">{{ item.name }}</div>
                  </li>
                </div>
            </div>
        </div>
          
        </ul>
  
        <div class="subNav">
          <ul v-if="subNavList.subNav">
            <li
              v-for="(snav, i) in subNavList.subNav"
              :key="i"
              :class="{ current: subNavList.subNavCurt === snav.type }"
              @click="changeNavSub(snav.type)"
            >
              {{ snav.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    

    <userList v-show="dataList" :dataList="dataList" :type="current" :topIsShow="topIsShow" :over1200="over1200" />
    <div v-show="isLoading && !isEnd" class="loading"></div>
    <div v-show="isEnd" class="noMore">已经全部加载完毕</div>
  </div>
</template>

<script>
import userList from "./UserList.vue";
import api from "@/api/tops";
import Swiper from "swiper";
import "@/utils/flexible";
export default {
  name: "agpTops",
  components: {
    userList,
  },
  data() {
    return {
      current: "gs",
      navList: [
        {
          type: "gs",
          name: "高手排行",
          ico: require("@/assets/img/tops/ico_gaoshou.png"),
          subNavCurt: "hot_rank",
          subNav: [
            {
              name: "热度榜",
              type: "hot_rank",
            },
            {
              name: "粉丝榜",
              type: "follow_nums",
            },
            // {
            //   name: "会员数",
            //   type: "vip_nums",
            // },
            {
              name: "按字母",
              type: "first_name",
            },
            {
              name: "新人榜",
              type: "rec_time",
            },
          ],
        },
        {
          type: "daRen",
          name: "达人排行",
          ico: require("@/assets/img/tops/ico_daren.png"),
          subNavCurt: "talent_rank",
          subNav: [
            {
              name: "热度榜",
              type: "talent_rank",
            },
            {
              name: "活跃榜",
              type: "talent_hot",
            },
            {
              name: "粉丝榜",
              type: "talent_fans",
            },
            {
              name: "新人榜",
              type: "talent_new"
            }
          ],
        },
        // {
        //   type: "tg",
        //   name: "投顾排行",
        //   ico: require("@/assets/img/tops/ico_tougu.png"),
        // },
        
        {
          type: "zhuanLan",
          name: "专栏排行",
          ico: require("@/assets/img/tops/ico_zhuanlan.png"),
        },
        {
          type: "mn",
          name: "模拟排行",
          ico: require("@/assets/img/tops/ico_moni.png"),
          appUrl:'?funToApp&kind=profit_rank&id=1',
          //需要跳转至app页面
        },
        {
          type: "stock",
          name: "股票排行", 
          ico: require("@/assets/img/tops/ico_stock.png"),
          appUrl:'https://mobile.aigupiao.com/up/tops#igpFunToAppJump_kind=stock_rise_rank',
          over1020:true,//是否需要判断10.2.0版本号
        },
        {
          type: "plate",
          name: "板块排行",
          ico: require("@/assets/img/tops/ico_plate.png"),
          appUrl:'https://mobile.aigupiao.com/up/tops#igpFunToAppJump_kind=theme_rank',
          over1020:true,
        },
      ],
      isLoading: false,
      isEnd: false,
      currentPage: 1,
      dataList: null,

      env: "",
      onType: null,
      oldScrollTop: 0,
      domHeight: 0,
      isIos: true,
      isIos12:true,
      topIsShow: false,
      over1020:false,//当前版本号是否10.2.0以上
      over1190: false, // 当前版本哈是否在11.9.0以上
      over1200: false, // 当前版本哈是否在12.0.0以上
      swiper2: null, // 轮波 - 两个组合卡片

      prevScrollPos: ""
    };
  },
  computed: {

    u_id(){
      return this.$route.query.u_id
    },

    subNavList() {
      return this.navList.find((item) => {
        return item.type === this.current;
      });
    },
  },
  created() {
    this.env = "";
    // this.env = this.$env;
    let u = navigator.userAgent;
    // let isiOS_ = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    
    this.isIos = true;
    this.isIos12 = true;
    // if (isiOS_) {
    //     this.isIos = true;
    //     this.isIos12 = true;
    //     const { devicePixelRatio, screen } = window;
    //     const { width, height } = screen;
    //     this.isIos12 = true;
    //     //iPhone12
    //     if(devicePixelRatio && devicePixelRatio === 3 && width === 390 && height === 844){
    //       this.isIos12 = true;
    //     }
    //     else if(devicePixelRatio && devicePixelRatio === 3 && width === 375 && height === 812 && false) {
    //       this.isIos12 = true;
    //     }
    // }

    //获取url参数
    function getQueryVariable(variable)
    {
        var query = window.location.search.substring(1);
        var vars = query.split("&");
        for (var i=0;i<vars.length;i++) {
            var pair = vars[i].split("=");
            if(pair[0] == variable){return pair[1];}
        }
        return(false);
    }

    var appversion = getQueryVariable('version') || '';
    
    this.over1020 = (appversion!=='' && (compareVersion(appversion,'10.2.0') >= 0));
    this.over1200 = (appversion!=='' && (compareVersion(appversion,'12.0.0') >= 0));


    //比较版本号大小
    function compareVersion(v1, v2) {
      if(v1.indexOf('.')> -1) {

      } else {
        let t_v1 = v1.split('.').join(''), t_v2 = v2.split('.').join('');
        if(t_v1 < t_v2) {
          return -1
        }
      }
        if (v1 == v2) {
            return 0;
        }
        var vs1 = v1.split(".").map(a => parseInt(a));
        var vs2 = v2.split(".").map(a => parseInt(a));

        console.info(vs1,vs2)

        var length = Math.min(vs1.length, vs2.length);
        for (var i = 0; i < length; i++) {
            if (vs1[i] > vs2[i]) {
                return 1;
            } else if (vs1[i] < vs2[i]) {
                return -1;
            }
        }

        if (length == vs1.length) {
            return -1;
        } else {
            return 1;
        }
    }

    if( appversion!=='' && (compareVersion(appversion,'10.1.0') >= 0)){
      let navList = this.navList;
      navList[0].subNav.push({
        name: "风格榜",
        type: "recommend_teacher"
      })

      this.navList = navList;
      this.$forceUpdate();
    }

    var topIsShow = getQueryVariable('topShow') || 'yes';
    var topCheck = getQueryVariable('topCheck') || 'hot_rank'; // hot_rank follow_nums first_name rec_time
    if(topIsShow == 'yes') {
      this.topIsShow = true;
    } else {
      this.topIsShow = false;
    }

    if(topCheck == 'hot_rank' || topCheck == 'follow_nums' || topCheck == 'first_name' || topCheck == 'rec_time') {
      this.$set(this.navList[0], 'subNavCurt', topCheck)
    }

    
    this.getData();
  },
  mounted() {
    this.prevScrollPos = window.pageYOffset;
    if(this.topIsShow) {
      this.domHeight = this.$refs["navWarpRF"].clientHeight;
    }
    this.$once("hook:beforeDestroy", () => {
      this.unbindScroll();
    });

    if(this.swiper2){
        this.swiper2.destroy(true);
    }
    this.$nextTick(() => {
        this.swiper2 = new Swiper(".swiper-container", {
            autoplay: false,
            freeMode: true,//滚动自由模式
            slidesPerView: "auto",
            initialSlide:0
        });
    });

    if(this.over1200){
      window.srNativeCallH5Method = (data) => {
          let params = null;
          if(this.source == 'ios') {
              params = JSON.parse(data);
          } else {
              params = this.handleSpecialCharacters(data);
          }
          if(params.method_name == 'return_focus_state') {
              //接收app传过来返回关注状态
            console.log('params.params',params.params)
            this.change_follow(params.params)
          } 
      };

      window.change_f = (person)=>{
        this.change_follow(person);
      }
    }


  },
  methods: {
    changeNav(item) {
      //跳转app页面
      if(item.appUrl){
        if(item.over1020){
          //需要判断版本号
          if(this.over1020){
            location.href = item.appUrl;
          }
          else{
            alert('请升级至最新版本~')
          }
        }
        else{
          location.href = item.appUrl;
        }
      }
      else {
        // 未变化 不触发数据加载
        if (this.current === item.type) return;

        if (this.isLoading) {
          console.log("请求响应中呢，别着急");
          return;
        }

        this.current = item.type;
        this.getData({ changeList: true });

        if(this.topIsShow) {
          this.$nextTick(()=>{
            this.domHeight = this.$refs["navWarpRF"].clientHeight;
          })
        }
      }
    },
    changeNavSub(type) {
      console.info(type,'type');
      if(type == 'recommend_teacher') {
        location.href = "?funToApp&kind=recommendTeacher";
        return
      }
      if (this.subNavList.subNavCurt === type) return;

      if (this.isLoading) {
        console.log("请求响应中呢，别着急");
        return;
      }

      this.subNavList.subNavCurt = type;
      this.getData({ changeList: true });
    },
    getData(pars) {
      if (this.isLoading) {
        console.log("请求响应中呢，别着急");
        return;
      }

      if (pars && pars.changeList) {
        console.log("切换了列表：", this.current, this.subNavList.subNavCurt);
        this.dataList = null;
        this.currentPage = 1;
        this.isEnd = false;
        this.unbindScroll();
      }

      // https://apisbeta.aigupiao.com/liver/month_live/?act=search&order_type=hot_rank&source=ios
      let params = {
        u_id: this.u_id,
        act: "search",
        order_type: this.subNavList.subNavCurt,
        source: "ios",
        page: this.currentPage,
        number: 20
      };
      this.isLoading = true;

      let url =
        this.subNavList.subNavCurt === "hot_rank"
          ? `https://apis${this.env}.aigupiao.com/liver/month_live/`
          : `https://app${this.env}.aigupiao.com/api2/live.php`;

      let resListName = "live_list";
      let apiFnName = "getGaoShouHot";
      if (this.current === "daRen") {
        apiFnName = "getGaoShouHot";
        url = `https://www${this.env}.aigupiao.com/v1/user/ranking`;
        // ${this.subNavList.subNavCurt}
        resListName = "info";
        let params_type = "";
        switch(this.subNavList.subNavCurt) {
          case "talent_rank": params_type = 'talent';break;
          case "talent_hot": params_type = 'talent_hot';break;
          case "talent_new": params_type = 'talent_new';break;
        }
        params = {
          type: params_type,
          number: 20,
          page: this.currentPage,
          u_id: this.u_id,
          md: "350c6848a28f9452447998b560f9d00c"
        }
      }

      if (this.current === "zhuanLan") {
        url = `https://api${this.env}.aigupiao.com/v1/rank/column_rank`;
        resListName = "info";
      }

      // 达人粉丝
      if(this.current == "daRen" && this.subNavList.subNavCurt == "talent_fans") {
        apiFnName = "getGaoShouHot";
        url = `https://www${this.env}.aigupiao.com/v1/user/ranking`;
        params = {
          type: "talent_fans",
          number: 20,
          page: this.currentPage,
          u_id: this.u_id,
        }
      }

      // 专栏排行
      if(this.current == "zhuanLan") {
        apiFnName = "getGaoShouHot";
        url = `https://www${this.env}.aigupiao.com/v1/user/ranking`;
        params = {
          type: "column",
          number: 20,
          page: this.currentPage,
          u_id: this.u_id,
        }
      }

      console.info(apiFnName, url, this.current, this.subNavList.subNavCurt)
      // 请求数据
      api[apiFnName](url, params).then((res) => {
        this.isLoading = false;
        console.log("res --", res);
        if (res.rslt === "succ") {
          let list = res[resListName];
          // 达人优化接口 - 更新逻辑
          if(this.current == "daRen" && this.subNavList.subNavCurt == "talent_fans") {
            console.info(list,'list');
            for(let i=0,ilen=list.length;i<ilen;i++) {
              if(list[i] && list[i].medals && list[i].medals.length > 0) {
                list[i].is_talent = 'yes';
              } else {
                list[i].is_talent = 'no';
              }
              list[i].u_id = list[i].id;
            }
          }

          // 专栏接口优化
          if(this.current == "zhuanLan") {
            const $darkUserArr = [716261, 714558];
            for(let i=list.length-1,ilen=0;i>=ilen;i--) {
              if($darkUserArr.indexOf(list[i].u_id) > -1) {
                list.splice(i, 1)
              }
            }
          }

          if (list.length > 0) {
            if (params.page === 1) {
              this.dataList = list;
            } else {
              this.dataList = [...this.dataList, ...list];
            }
            this.currentPage = params.page + 1;
            this.bindScroll();
          } else {
            this.isEnd = true;
            //this.unbindScroll();
          }
        } else {
          console.log("error");
        }
      });
    },

    bindScroll() {
      $(window).on("scroll", () => {
        let page_scroll = $(window).scrollTop();
        var isToEndl =  page_scroll + $(window).height() >  $(document).height() - 40;

        if(this.isIos && !this.isIos12 && !this.over1190) {
          $(this.$refs['navWarpRF']).css('top', page_scroll + 'px')
        }
        
        if (!this.isLoading && !this.isEnd && isToEndl) {
          this.getData();
        }
      });

      if(!this.isIos || (this.isIos && this.over1190)) {
        window.addEventListener("scroll", this.handleScroll, true);  
      }
    },
    handleScroll() {
      // 页面滚动距顶部距离
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      let scroll = scrollTop - this.oldScrollTop;
      this.oldScrollTop = scrollTop;
 
      console.log('滚动。。。',scroll,scrollTop,this.domHeight)
      if(scrollTop > this.domHeight) {
        // 鼠标向上滚动
        if (scroll > 2) { //  && 
          this.onType = 'bind_down'
        } else {
          // 鼠标向下滚动
          this.onType = 'bind_up'
        }
      } else {
        this.onType = ''
      }

      // var currentScrollPos = window.pageYOffset;
  
      // if (this.prevScrollPos > currentScrollPos) {
      //   // 向上滚动，显示菜单
      //   // document.getElementById("menu-container").style.top = "0";
      //   this.onType = 'bind_up'
      // } else {
      //   // 向下滚动，隐藏菜单
      //   // document.getElementById("menu-container").style.top = "-50px";
      //   this.onType = 'bind_down'
      // }
      
      // this.prevScrollPos = currentScrollPos;
    },

    unbindScroll() {
      $(window).off("scroll");
      if(!this.isIos || (this.isIos && this.over1190)) {
        window.removeEventListener("scroll", this.handleScroll, true);
      }
      this.currentPage = 1;
    },
    change_follow(person){
      //改变关注状态 
      if(person.kind == 'teacher'){
        this.dataList = this.dataList.map((item)=>{
          if(item.id == person.l_id || item.l_id == person.l_id){
            item.is_follow = person.focus;
          }
          return item;
        })
      }
      else if(person.kind == 'user'){
        this.dataList = this.dataList.map((item)=>{
          if(item.u_id == person.u_id || item.user_id == person.u_id){
            item.is_follow = person.focus;
          }
          return item;
        })
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/sass/global.scss";

@function imgmask($c) {
  @return 0 rem(5px) rem(22px) rem(2px) $c;
}

.topsPage {

  &.isIos {
    padding-top: rem(321.35px);
  }
  
  .navWarp {
    position: relative;
    top: 0;
    height: rem(321.35px);

    &.zhuanLan {
      height: rem(210px);
    }

    &.isIos {
      // position: sticky;
      height: unset;
      position: absolute;
      width: 100%;
      top: 0;
    }

    &.isIos12{
      position: relative;
    }

    &.bind_down {
      // z-index: -1;

      .navWrapPos {
        transform: translateY(-321.35px);
        // transition: transform .3s;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
      }
    }

    &.bind_up {
      z-index: 1;

      .navWrapPos {
        transform: translateY(0);
        transition: transform .3s;
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
      }
    }

    .headNav {
      display: flex;
      padding: 15px 0;
      background: $a-dl-121212-fff;
      flex-wrap: nowrap;
      overflow: hidden;
      width: 100%;
      // overflow-x: auto;
	  
      li {
        text-align: center;
        width: 22.22%;
        flex-shrink: 0;
		
        img {
          width: 42px;
          height: 42px;
          border-radius: 50%;
          display: block;
          margin: 0 auto 11px;
        }
        .name {
          color: $a-dl-f3-63;
          font-size: 13px;
        }
        &.current {
          .name {
            font-weight: bold;
          }
          img{
            box-shadow: imgmask(#F9C97A);
            &.img1{
              box-shadow: imgmask(#80B3EF);
            }
            &.img2{
              box-shadow: imgmask(#8FBFF5);
            }
            &.img3{
              box-shadow: imgmask(#F6AD8A);
            }
          }
        }
      }
    }

    .subNav {
      background: $a-dl-121212-f8f8f8;
      padding-top: 8px;
	  
      ul {
        display: flex;
        justify-content: space-around;
        background: $a-dl-121212-fff;
        border-bottom: #e2e2e2 0.5px solid;
        li {
          color: $a-dl-b7-63;
          font-size: 15px;
          height: 52px;
          line-height: 52px;
          &.current {
            font-weight: bold;
            border-bottom: #fe484a 2.5px solid;
          }
        }
      }
    }
  }

  .loading {
    padding: 25px 0;
    height: 25px;
    background: url("../../assets/images/loading.gif") no-repeat center;
    background-size: 25px;
  }
  .noMore {
    text-align: center;
    font-size: 13px;
    line-height: 50px;
    color: #999;
  }

  & > ul {
    background-color: $a-dl-121212-fff;
  }
}
*{
  touch-action: pan-x pan-y;
}
.swiper2{
  width: 100%;
}

.tab2.swiper2{
  .swiper-container{
      height: 100%;
  }
  
}
</style>
<style>
	#app {
		background-color: transparent;
	}
</style>